export default "__VITE_ASSET__BRTm_qPI__"